import Image from "next/image";
import ball_1062_1 from "@/assets/ball/1062/1.png";
import ball_1062_2 from "@/assets/ball/1062/2.png";
import ball_1062_3 from "@/assets/ball/1062/3.png";
import ball_1062_4 from "@/assets/ball/1062/4.png";
import ball_1062_5 from "@/assets/ball/1062/5.png";
import ball_1062_6 from "@/assets/ball/1062/6.png";
import ball_1062_7 from "@/assets/ball/1062/7.png";
import ball_1062_8 from "@/assets/ball/1062/8.png";
import ball_1062_9 from "@/assets/ball/1062/9.png";
import ball_1062_10 from "@/assets/ball/1062/10.png";
import ball_1063_0 from "@/assets/ball/1063/0.png";
import ball_1063_1 from "@/assets/ball/1063/1.png";
import ball_1063_2 from "@/assets/ball/1063/2.png";
import ball_1063_3 from "@/assets/ball/1063/3.png";
import ball_1063_4 from "@/assets/ball/1063/4.png";
import ball_1063_5 from "@/assets/ball/1063/5.png";
import ball_1063_6 from "@/assets/ball/1063/6.png";
import ball_1063_7 from "@/assets/ball/1063/7.png";
import ball_1063_8 from "@/assets/ball/1063/8.png";
import ball_1063_9 from "@/assets/ball/1063/9.png";
import ball_1068_1 from "@/assets/ball/1068/1.png";
import ball_1068_2 from "@/assets/ball/1068/2.png";
import ball_1068_3 from "@/assets/ball/1068/3.png";
import ball_1068_4 from "@/assets/ball/1068/4.png";
import ball_1068_5 from "@/assets/ball/1068/5.png";
import ball_1068_6 from "@/assets/ball/1068/6.png";
import ball_1070_1 from "@/assets/ball/1070/1.png";
import ball_1070_2 from "@/assets/ball/1070/2.png";
import ball_1070_3 from "@/assets/ball/1070/3.png";
import ball_1070_4 from "@/assets/ball/1070/4.png";
import ball_1070_5 from "@/assets/ball/1070/5.png";
import ball_1070_6 from "@/assets/ball/1070/6.png";
import ball_1070_7 from "@/assets/ball/1070/7.png";
import ball_1070_8 from "@/assets/ball/1070/8.png";
import ball_1070_9 from "@/assets/ball/1070/9.png";
import ball_1070_10 from "@/assets/ball/1070/10.png";
import ball_1070_11 from "@/assets/ball/1070/11.png";
import ball_1070_12 from "@/assets/ball/1070/12.png";
import ball_1070_13 from "@/assets/ball/1070/13.png";
import ball_1070_14 from "@/assets/ball/1070/14.png";
import ball_1070_15 from "@/assets/ball/1070/15.png";
import ball_1070_16 from "@/assets/ball/1070/16.png";
import ball_1070_17 from "@/assets/ball/1070/17.png";
import ball_1070_18 from "@/assets/ball/1070/18.png";
import ball_1070_19 from "@/assets/ball/1070/19.png";
import ball_1070_20 from "@/assets/ball/1070/20.png";
import ball_1070_21 from "@/assets/ball/1070/21.png";
import ball_1070_22 from "@/assets/ball/1070/22.png";
import ball_1070_23 from "@/assets/ball/1070/23.png";
import ball_1070_24 from "@/assets/ball/1070/24.png";
import ball_1070_25 from "@/assets/ball/1070/25.png";
import ball_1070_26 from "@/assets/ball/1070/26.png";
import ball_1070_27 from "@/assets/ball/1070/27.png";
import ball_1070_28 from "@/assets/ball/1070/28.png";
import ball_1070_29 from "@/assets/ball/1070/29.png";
import ball_1070_30 from "@/assets/ball/1070/30.png";
import ball_1070_31 from "@/assets/ball/1070/31.png";
import ball_1070_32 from "@/assets/ball/1070/32.png";
import ball_1070_33 from "@/assets/ball/1070/33.png";
import ball_1070_34 from "@/assets/ball/1070/34.png";
import ball_1070_35 from "@/assets/ball/1070/35.png";
import ball_1070_36 from "@/assets/ball/1070/36.png";
import ball_1070_37 from "@/assets/ball/1070/37.png";
import ball_1070_38 from "@/assets/ball/1070/38.png";
import ball_1070_39 from "@/assets/ball/1070/39.png";
import ball_1070_40 from "@/assets/ball/1070/40.png";
import ball_1070_41 from "@/assets/ball/1070/41.png";
import ball_1070_42 from "@/assets/ball/1070/42.png";
import ball_1070_43 from "@/assets/ball/1070/43.png";
import ball_1070_44 from "@/assets/ball/1070/44.png";
import ball_1070_45 from "@/assets/ball/1070/45.png";
import ball_1070_46 from "@/assets/ball/1070/46.png";
import ball_1070_47 from "@/assets/ball/1070/47.png";
import ball_1070_48 from "@/assets/ball/1070/48.png";
import ball_1070_49 from "@/assets/ball/1070/49.png";
import ball_marble_1 from "@/assets/ball/marble/1.png";
import ball_marble_2 from "@/assets/ball/marble/2.png";
import ball_marble_3 from "@/assets/ball/marble/3.png";
import ball_marble_4 from "@/assets/ball/marble/4.png";
import ball_marble_5 from "@/assets/ball/marble/5.png";
import ball_marble_6 from "@/assets/ball/marble/6.png";
import ball_marble_7 from "@/assets/ball/marble/7.png";
import ball_marble_8 from "@/assets/ball/marble/8.png";
import ball_marble_9 from "@/assets/ball/marble/9.png";
import ball_marble_10 from "@/assets/ball/marble/10.png";

import { isMarbleGame } from "@/lib/utils";

const balls = {
  "1062": {
    1: ball_1062_1,
    2: ball_1062_2,
    3: ball_1062_3,
    4: ball_1062_4,
    5: ball_1062_5,
    6: ball_1062_6,
    7: ball_1062_7,
    8: ball_1062_8,
    9: ball_1062_9,
    10: ball_1062_10,
  },
  "1063": {
    0: ball_1063_0,
    1: ball_1063_1,
    2: ball_1063_2,
    3: ball_1063_3,
    4: ball_1063_4,
    5: ball_1063_5,
    6: ball_1063_6,
    7: ball_1063_7,
    8: ball_1063_8,
    9: ball_1063_9,
  },
  "1068": {
    1: ball_1068_1,
    2: ball_1068_2,
    3: ball_1068_3,
    4: ball_1068_4,
    5: ball_1068_5,
    6: ball_1068_6,
  },
  "1070": {
    1: ball_1070_1,
    2: ball_1070_2,
    3: ball_1070_3,
    4: ball_1070_4,
    5: ball_1070_5,
    6: ball_1070_6,
    7: ball_1070_7,
    8: ball_1070_8,
    9: ball_1070_9,
    10: ball_1070_10,
    11: ball_1070_11,
    12: ball_1070_12,
    13: ball_1070_13,
    14: ball_1070_14,
    15: ball_1070_15,
    16: ball_1070_16,
    17: ball_1070_17,
    18: ball_1070_18,
    19: ball_1070_19,
    20: ball_1070_20,
    21: ball_1070_21,
    22: ball_1070_22,
    23: ball_1070_23,
    24: ball_1070_24,
    25: ball_1070_25,
    26: ball_1070_26,
    27: ball_1070_27,
    28: ball_1070_28,
    29: ball_1070_29,
    30: ball_1070_30,
    31: ball_1070_31,
    32: ball_1070_32,
    33: ball_1070_33,
    34: ball_1070_34,
    35: ball_1070_35,
    36: ball_1070_36,
    37: ball_1070_37,
    38: ball_1070_38,
    39: ball_1070_39,
    40: ball_1070_40,
    41: ball_1070_41,
    42: ball_1070_42,
    43: ball_1070_43,
    44: ball_1070_44,
    45: ball_1070_45,
    46: ball_1070_46,
    47: ball_1070_47,
    48: ball_1070_48,
    49: ball_1070_49,
  },
  marble: {
    1: ball_marble_1,
    2: ball_marble_2,
    3: ball_marble_3,
    4: ball_marble_4,
    5: ball_marble_5,
    6: ball_marble_6,
    7: ball_marble_7,
    8: ball_marble_8,
    9: ball_marble_9,
    10: ball_marble_10,
  },
};

export function GameBall({
  gameType,
  roomId,
  num,
  width,
  height,
}: {
  gameType: string;
  roomId?: string;
  num: number;
  width: number;
  height: number;
}) {
  const isMarble = isMarbleGame(roomId ?? "");

  return (
    <Image
      src={balls[isMarble ? "marble" : gameType][num]}
      alt={`ball-${gameType}-${num}`}
      width={width}
      height={height}
    />
  );
}
